export default "__VITE_ASSET__8fcd3119__"